// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"1f988a67","72":"073f73f7","477":"cba7256f","627":"099d331e","663":"aad0c761","667":"b9eb6061","777":"f74ed9f0","803":"232440df","820":"a7fe6c6a"}[chunkId] + ".chunk.js";
};